import { Controller } from "@hotwired/stimulus"
import { DirectUpload } from "@rails/activestorage"

// Connects to data-controller="add-eligibility-files"
export default class extends Controller {
  static targets = [
    "files",
    "uploadForm",
    "uploadProgressContainer",
    "uploadProgressPercentage"
  ];

  connect() {
    ['dragenter', 'dragover', 'dragleave', 'drop'].forEach(eventName => {
      this.uploadFormTarget.addEventListener(eventName, this.dragHandler.bind(this), false)
    });
  }

  pickFile(e) {
    this.filesTarget.click()
  }

  filePicked(e) {
    this.uploadFiles(e.target.files)
  }

  uploadFiles(files) {
    console.log("files", files)
    this.uploadProgressContainerTarget.classList.remove('hidden')
    this.uploadProgressPercentageTarget.innerText = '5'

    this.uploadFormTarget.classList.add("hidden")

    // remove any previously added hidden fields with data-blob="true"
    this.uploadFormTarget.querySelectorAll('input[data-blob="true"]').forEach((el) => {
      el.remove()
    })

    var uploader = new EligibilityFileUploader(files[0], this.uploadProgressPercentageTarget)
    uploader.beginUpload((success, error, blob) => {

      if (success) {
        const hiddenBlobField = document.createElement('input')
        hiddenBlobField.setAttribute("type", "hidden")
        hiddenBlobField.setAttribute("value", blob.signed_id)
        hiddenBlobField.dataset.blob = "true"
        hiddenBlobField.name = "file"
        this.uploadFormTarget.appendChild(hiddenBlobField)  
        this.uploadFormTarget.submit()
      } else {
        console.log("error", error)
      }
    })
  }

  dragHandler(e) {
    e.preventDefault();
    e.stopPropagation();

    if ([ 'dragenter', 'dragover' ].includes(e.type)) {
      this.uploadFormTarget.classList.add("!bg-light-gray")
    } else {
      this.uploadFormTarget.classList.remove("!bg-light-gray")
    }

    if (e.type === 'drop') {
      this.uploadFiles(e.dataTransfer.files)
    }
  }
}

class EligibilityFileUploader {
  constructor(file, progressPercentage) {
    this.file = file
    this.upload = new DirectUpload(this.file, "/rails/active_storage/direct_uploads", this)
    this.progressPercentage = progressPercentage
  }

  beginUpload(callback) {
    this.upload.create((error, blob) => {
      if (error) {
        // Handle the error
        callback(false, error, null)
      } else {
        callback(true, null, blob)
      }
    })
  }

  directUploadWillStoreFileWithXHR(request) {
    request.upload.addEventListener("progress",
      event => this.directUploadDidProgress(event))
  }

  directUploadDidProgress(event) {
    // Use event.loaded and event.total to update the progress bar
    var progress = Math.round(event.loaded / event.total * 100)

    // Don't go over 95% because we still do some processing when we redirect to the next page, which means there's
    // still a bit of work to be done.
    if (progress > 95) {
      progress = 95
    }
    this.progressPercentage.innerText = progress
  }
}